import store from '@/store'

function parseBinding (binding) {
  const value = binding.value
  const raw = (value && typeof value === 'object') ? value.key : value
  const label = (value && typeof value === 'object')
    ? (value.label || value.key)
    : (binding.arg ? decodeURIComponent(binding.arg) : value)

  // Backend feature keys are stored/returned lowercase; normalize here so
  // markers written in any case still match company-features/me lookups.
  return { key: raw ? String(raw).toLowerCase() : raw, label }
}

function applyVisibility (el, key) {
  const allowed = store.getters['companyFeatures/hasFeature'](key)
  el.style.display = allowed ? '' : 'none'
  el.classList.toggle('feature-restricted', !allowed)
}

function findIconName (el) {
  const iconEl = el.classList?.contains('v-icon') ? el : el.querySelector?.('.v-icon')
  if (!iconEl) {
    return null
  }

  const mdiClass = Array.from(iconEl.classList).find(cls => cls.startsWith('mdi-'))
  return mdiClass || null
}

export default {
  bind (el, binding) {
    const { key, label } = parseBinding(binding)
    if (!key) {
      return
    }

    el.setAttribute('data-feature-key', key)
    if (label) {
      el.setAttribute('data-feature-label', label)
    }

    const icon = findIconName(el)
    if (icon) {
      el.setAttribute('data-feature-icon', icon)
    }

    applyVisibility(el, key)

    el._featureKeyUnwatch = store.watch(
      (rootState, rootGetters) => rootGetters['companyFeatures/hasFeature'](key),
      () => applyVisibility(el, key),
    )
  },

  update (el, binding) {
    const { key: newKey } = parseBinding(binding)
    const { key: oldKey } = parseBinding({ value: binding.oldValue, arg: binding.arg })

    if (newKey !== oldKey) {
      if (el._featureKeyUnwatch) {
        el._featureKeyUnwatch()
      }
      el.setAttribute('data-feature-key', newKey || '')
      applyVisibility(el, newKey)
      el._featureKeyUnwatch = store.watch(
        (rootState, rootGetters) => rootGetters['companyFeatures/hasFeature'](newKey),
        () => applyVisibility(el, newKey),
      )
    }
  },

  unbind (el) {
    if (el._featureKeyUnwatch) {
      el._featureKeyUnwatch()
      el._featureKeyUnwatch = null
    }
  },
}
